import { render, staticRenderFns } from "./RolesLength.vue?vue&type=template&id=e2bdf2d6"
import script from "./RolesLength.vue?vue&type=script&lang=js"
export * from "./RolesLength.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports